import { SearchParamKey } from '@app/store/appStore.types'

// login_origin_domain is intentionally session-scoped and kept separate from the
// persistent signup attribution params below — it must never overwrite or be confused
// with a user's historical signup_origin_domain.
export const SESSION_SEARCH_PARAMS = [
    SearchParamKey.ACCESS_TOKEN,
    SearchParamKey.REFRESH_TOKEN,
    SearchParamKey.REDIRECT_URL,
    SearchParamKey.LOGIN_ORIGIN_DOMAIN,
]

export const PERSISTENT_SEARCH_PARAMS = [
    SearchParamKey.COMPANY_INVITE_ID,
    SearchParamKey.REF_CODE,
]

// Captured once on landing on /sign-up* and persisted (localStorage) across every
// step of the multi-step signup flow, even once the query params are gone from the URL.
export const SIGNUP_ATTRIBUTION_SEARCH_PARAMS = [
    SearchParamKey.SIGNUP_ORIGIN_DOMAIN,
    SearchParamKey.SIGNUP_ORIGIN_PATH,
    SearchParamKey.LANDING_PAGE,
    SearchParamKey.REFERRER,
    SearchParamKey.UTM_SOURCE,
    SearchParamKey.UTM_MEDIUM,
    SearchParamKey.UTM_CAMPAIGN,
    SearchParamKey.UTM_CONTENT,
    SearchParamKey.UTM_TERM,
]
